<template>
  <section class="customer-section">
    <div class="section-container">
      <header class="section-heading">
        <h2>与客户共同沉淀档案价值</h2>
        <p>服务政府机关、企事业单位与高校，为不同组织的档案数字化建设提供长期支持。</p>
      </header>
      <div class="featured-customers">
        <article v-for="item in companyList1" :key="item.name" class="featured-customer">
          <img :src="item.url" :alt="item.name" />
          <span>{{ item.name }}</span>
        </article>
      </div>
      <div class="customer-grid">
        <article v-for="item in companyList" :key="item.name" class="customer-item">
          <img :src="item.url" :alt="item.name" />
          <span>{{ item.name }}</span>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import Archives from '@/assets/images/logo_achrive.png'

export default {
  data () {
    return {
      companyList: [
        { url: Archives, name: '太原市档案馆' }, { url: Archives, name: '运城市档案馆' }, { url: Archives, name: '永济市档案馆' }, { url: Archives, name: '万荣县档案馆' },
        { url: Archives, name: '平城区卫体局' }, { url: Archives, name: '永济市卫体局' }, { url: Archives, name: '永济市国家税局' }, { url: require('@/assets/images/logo-government.png'), name: '永济市行政审批管理局' },
        { url: require('@/assets/images/logo-government.png'), name: '中共山西省纪律检查委员会' }, { url: require('@/assets/images/logo-government.png'), name: '中共山西省委政法委员会' }, { url: require('@/assets/images/logo-government.png'), name: '稷山县人民法院' }, { url: require('@/assets/images/logo-government.png'), name: '稷山县人民检察院' },
        { url: require('@/assets/images/logo-government.png'), name: '平顺县人民检察院' }, { url: require('@/assets/images/logo-government.png'), name: '盐湖区人民检察院' }, { url: require('@/assets/images/logo-government.png'), name: '山西省自然资源厅' }, { url: require('@/assets/images/logo-government.png'), name: '临汾开发区土地分局' },
        { url: require('@/assets/images/logo-government.png'), name: '太长高速公路有限责任公司' }, { url: require('@/assets/images/logo-government.png'), name: '长治市第三中学校' }, { url: require('@/assets/images/logo-government.png'), name: '长治市特殊教育学校' }, { url: require('@/assets/images/logo-government.png'), name: '太原市人民防空办公室' },
        { url: require('@/assets/images/logo-government.png'), name: '长治市烟草公司' }, { url: require('@/assets/images/logo-government.png'), name: '太原市公安局' }, { url: require('@/assets/images/logo-government.png'), name: '山西省人民政府外事办公室' }
      ],
      companyList1: [
        { url: require('@/assets/images/khlog/山西省档案馆.png'), name: '山西省档案馆' }, { url: require('@/assets/images/khlog/山西省法学会.png'), name: '山西省法学会' },
        { url: require('@/assets/images/khlog/省纪委驻山西省水利局.png'), name: '纪委驻山西省水利厅纪检组' }, { url: require('@/assets/images/khlog/山西省自然开发局阳泉分局.png'), name: '自然资源厅阳泉土地分局' },
        { url: require('@/assets/images/khlog/太原市市场监督管理局.png'), name: '太原市市场监督管理局' }, { url: require('@/assets/images/khlog/山西省自然资源厅.png'), name: '山西省自然资源厅' },
        { url: require('@/assets/images/khlog/山西博物院.png'), name: '山西博物院' }, { url: require('@/assets/images/khlog/山西省农业农村厅.png'), name: '山西省农业农村厅' },
        { url: require('@/assets/images/khlog/山西省乡村振兴局.png'), name: '山西省乡村振兴局' }, { url: require('@/assets/images/khlog/山西出版传媒集团.png'), name: '山西出版传媒集团' },
        { url: require('@/assets/images/khlog/太原市人民代表大会常委会.png'), name: '太原人民常务委员会办公室' }, { url: require('@/assets/images/khlog/山西交通养护公司.png'), name: '山西交控养护集团' },
        { url: require('@/assets/images/khlog/山西省残疾人联合.png'), name: '山西省残疾人联合会' }, { url: require('@/assets/images/khlog/山西市场监督管理局.png'), name: '山西省市场监督管理局' },
        { url: require('@/assets/images/khlog/山西省防空办公室.png'), name: '山西省人民防空办公室' }, { url: require('@/assets/images/khlog/临汾职业技术学院.png'), name: '临汾职业技术学院' }
      ]
    }
  }
}
</script>

<style scoped>
.customer-section { padding: 106px 0 112px; background: #f5f8fc; }
.section-container { width: min(1200px, calc(100% - 64px)); margin: 0 auto; }
.section-heading { max-width: 700px; margin: 0 auto 46px; text-align: center; }
.section-heading h2 { margin: 0; color: #20344e; font-size: clamp(30px, 3vw, 40px); font-weight: 600; }
.section-heading > p:last-child { margin: 17px 0 0; color: #728197; font-size: 16px; line-height: 1.8; }
.featured-customers { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 12px; }
.featured-customer, .customer-item { display: flex; min-height: 88px; align-items: center; justify-content: center; gap: 10px; padding: 12px; border: 1px solid #e1e8f1; background: #fff; }
.featured-customer img { max-width: 138px; max-height: 42px; object-fit: contain; }
.featured-customer span { color: #4d6079; font-size: 13px; }
.customer-grid { display: grid; grid-template-columns: repeat(6, 1fr); border-top: 1px solid #e1e8f1; border-left: 1px solid #e1e8f1; }
.customer-item { min-height: 82px; border-top: 0; border-left: 0; border-right: 1px solid #e1e8f1; border-bottom: 1px solid #e1e8f1; }
.customer-item img { width: 26px; height: 26px; object-fit: contain; }
.customer-item span { color: #61748b; font-size: 12px; line-height: 1.45; }
@media (max-width: 1024px) { .featured-customers { grid-template-columns: repeat(2, 1fr); } .customer-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 768px) { .customer-section { padding: 72px 0; } .section-container { width: calc(100% - 40px); } .section-heading { margin-bottom: 34px; } .section-heading > p:last-child { font-size: 14px; } .featured-customers { grid-template-columns: 1fr; } .customer-grid { grid-template-columns: repeat(2, 1fr); } .featured-customer, .customer-item { min-height: 74px; } .featured-customer span, .customer-item span { font-size: 11px; } }
</style>
